// extracted by mini-css-extract-plugin
module.exports = {"container":"_5D26Eup5","text-field":"_5D2EqG_X","agree":"_5D3ui4Dp","agree__root":"_5DzUldux","agree__label":"_5D3Sz7YS","agree__link":"_5D2Gjs_H"};